import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';

export const SIZE = {
  initial: undefined,
  xSmall: '24px',
  small: '36px',
  medium: '48px',
  large: '64px',
  xLarge: '80px',
  xxLarge: '120px'
};

export const defaultSvgIconProps = {
  size: 'medium'
};

export const SvgContainer = ({ children, size }) => {
  const width = SIZE[size];
  const height = SIZE[size];
  return (
    <Box
      sx={{
        width,
        height,
        svg: {
          width: '100%',
          height: '100%',
          backgroundColor: 'transparent'
        }
      }}
    >
      {children}
    </Box>
  );
};

SvgContainer.propTypes = {
  size: PropTypes.string,
  children: PropTypes.node.isRequired
};

SvgContainer.defaultProps = defaultSvgIconProps;

export default SvgContainer;
